// O mesmo canal é usado pelo FCM, pelo Manifest e pelos avisos locais.
export const CANAL_AVISOS = {
  id: "pc_avisos",
  name: "Avisos do Print Control",
  description: "Mensagens de clientes, pedidos e atualizações",
  importance: 4,
  visibility: 0,
  vibration: true,
  lights: true,
  lightColor: "#00d4aa",
};
export const CANAIS_NOTIFICACOES = [
  CANAL_AVISOS,
  { ...CANAL_AVISOS, id: "pc_suporte", name: "Mensagens do suporte", description: "Respostas e contatos da equipe de suporte" },
  { ...CANAL_AVISOS, id: "pc_comunicados", name: "Comunicados do aplicativo", description: "Avisos gerais enviados pelo administrador", importance: 3 },
  { ...CANAL_AVISOS, id: "pc_aniversarios", name: "Aniversários de clientes", description: "Lembrete diário de aniversariantes", importance: 3 },
];

let permissaoPendente;

// O registro push e o aviso de versão podem iniciar juntos. Não abrir duas
// solicitações concorrentes para a mesma permissão POST_NOTIFICATIONS.
export function permissaoNotificacoesAndroid(solicitar = true) {
  if (permissaoPendente) return permissaoPendente;
  permissaoPendente = (async () => {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    let { receive } = await PushNotifications.checkPermissions();
    if (solicitar && ["prompt", "prompt-with-rationale"].includes(receive)) {
      ({ receive } = await PushNotifications.requestPermissions());
    }
    return receive === "granted";
  })().finally(() => { permissaoPendente = null; });
  return permissaoPendente;
}

// Só destinos internos conhecidos; nunca abrir URLs vindas do payload push.
export function destinoNotificacao(data = {}, uid) {
  if (!data || typeof data !== "object") return null;
  if (data.recipientId && data.recipientId !== uid) return null;
  switch (data.type) {
    case "suporte": return { tab: "config", secao: "suporte" };
    case "suporte_admin": return { tab: "admin", secao: "suporte" };
    case "app_comunicado": return { tab: "dashboard" };
    case "birthday": return { tab: "clientes" };
    case "chat_loja": return { tab: "site", secao: "mensagens" };
    case "chat":
    case "pedido_site": return { tab: "site", secao: "pedidos" };
    case "pedido_orcamento": return { tab: "pedidos" };
    // Pagamento confirmado pelo servidor: abre o pedido (id conferido antes de usar)
    case "pagamento_recebido": return /^[A-Za-z0-9_-]{1,128}$/.test(String(data.pedidoId || "")) ? { tab: "pedidos", pedidoId: data.pedidoId } : { tab: "pedidos" };
    case "mp_alerta": return { tab: "config", secao: "pagamentos" };
    case "app_update": return { tab: "config", secao: "downloads" };
    case "assinatura_expirando": return { tab: "config", secao: "conta" };
    case "filamento_baixo": return { tab: "filamentos" };
    case "venda_consignada": return { tab: "parceiros" };
    default: return null;
  }
}

let statusPush = { estado: "aguardando" };
const ouvintes = new Set();
export const obterStatusPush = () => statusPush;
export function atualizarStatusPush(status) {
  statusPush = status;
  ouvintes.forEach(fn => fn(status));
}
export function observarStatusPush(fn) {
  ouvintes.add(fn);
  return () => ouvintes.delete(fn);
}
